import * as Sentry from '@sentry/browser'

export default (opts) => {
  // const { getActiveApps = () => [], ignoredApps = [] } = opts || {}
  if (process.env.NODE_ENV !== 'production') {
    console.log('Sentry was disabled, skipping setup')
    return
  }

  Sentry.init({
    dsn: 'https://4c7c330073d34d25ba00bce77eca53ba@error-tracking.cloud.wanyplace.de/6152621',

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    integrations: [Sentry.browserTracingIntegration()],
    ignoreErrors: [
      'ScriptExternalLoadError',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications'
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,
    release: '__release__',
    environment: '__environment__'
  })

  Sentry.setTag('tenant', '__tenantId__')
  Sentry.setTag('brand', '__brandId__')
  Sentry.setTag('resourceId', '__resourceId__')
  Sentry.setTag('app', 'ds-orders-shell')
}
